import { render, staticRenderFns } from "./FiltersContainer.vue?vue&type=template&id=83bfc90a&scoped=true"
import script from "./FiltersContainer.ts?vue&type=script&lang=ts&external"
export * from "./FiltersContainer.ts?vue&type=script&lang=ts&external"
import style0 from "./FiltersContainer.vue?vue&type=style&index=0&id=83bfc90a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bfc90a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83bfc90a')) {
      api.createRecord('83bfc90a', component.options)
    } else {
      api.reload('83bfc90a', component.options)
    }
    module.hot.accept("./FiltersContainer.vue?vue&type=template&id=83bfc90a&scoped=true", function () {
      api.rerender('83bfc90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UnprocessedMarketerFiles/components/FiltersContainer/FiltersContainer.vue"
export default component.exports